import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const { config, response } = error;
    if (response?.status === 401 && !config.__retried && !config.url.includes("/auth/")) {
      config.__retried = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      try {
        await refreshing;
        return api(config);
      } catch {
        // fall through to reject
      }
    }
    return Promise.reject(error);
  }
);

export const fileUrl = (p) => (p && p.startsWith("/api") ? `${BACKEND}${p}` : p);

export const formatApiError = (e) => {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  return String(detail);
};

export default api;
